import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Crown } from 'lucide-react';
export function TrustStrip() {
  const trustSignals = ['15+ Years Serving Communities', 'Trusted by Thousands of Households', 'Multiple Locations Across the U.S.'];
  return <div className="bg-brand-black border-b border-brand-gold/20 py-6 md:py-4" data-id="element-246">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-247">
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8" data-id="element-248">
          {trustSignals.map((signal, index) => <Fragment key={index} data-id="element-249">
              <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="text-brand-gold font-medium text-sm md:text-base text-center tracking-wide" data-id="element-250">
                {signal}
              </motion.div>
              {index < trustSignals.length - 1 && <div className="hidden md:block text-brand-gold/50" data-id="element-251">
                  <Crown size={16} data-id="element-252" />
                </div>}
            </Fragment>)}
        </div>
      </div>
    </div>;
}